<template>
  <form
    @submit.prevent
    @click="click"
    :action="action"
    :method="method"
    @input="handleInput"
    @change="handleChange"
    autocomplete="off"
    ref="form"
    novalidate
  >
    <slot :submitting="submitting" :errors="errors"></slot>
  </form>
</template>

<script>
import axios from "axios";
// prettier-ignore
import { isEmpty, convertServerErrors, grabValidityErrors, focusFirstError } from "@/functions";

export default {
  props: {
    action: {
      type: String,
      required: true
    },
    method: {
      type: String,
      default: "post"
    },
    formData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      submitting: false,
      errors: {}
    };
  },

  methods: {
    click(event) {
      if (event.target.type === "submit") {
        event.preventDefault();
        this.checkAndSubmit();
      }
    },

    checkAndSubmit() {
      let form = this.$refs.form;

      // Components can implement a "validationError" computed property to provide a custom error
      let customErrors = this.collectCustomValidationErrors();

      if (form.checkValidity() && isEmpty(customErrors)) {
        this.submit();
      } else {
        let errors = { ...grabValidityErrors(form), ...customErrors };
        this.handleErrors(errors);
      }
    },

    collectCustomValidationErrors() {
      let errors = {};

      this.$children
        .filter(child => child.validationError)
        .forEach(child => (errors[child.name] = child.validationError));

      return errors;
    },

    submit() {
      let data = { ...this.formData };

      this.submitting = true;

      axios[this.method](this.action, data)
        .then(response => {
          this.submitting = false;
          this.$emit("success", response.data);
        })
        .catch(error => {
          this.handleErrors(convertServerErrors(error.response));
          this.$emit("failure", error.response);
        });
    },

    handleErrors(errors) {
      this.errors = errors;
      this.submitting = false;
      focusFirstError(this.$refs.form);
    },

    handleInput(event) {
      let name = event.target.name;

      if (!name) return;

      this.errors[name] = "";
    },

    handleChange(event) {
      let name = event.target.name;

      if (!name) return;

      this.errors[name] = "";
    }
  }
};
</script>
